import { useState, useEffect, useCallback } from "react";
import { Check, Loader2, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentReturn() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | success | failed | timeout

  const poll = useCallback(async (attempt = 0) => {
    if (!sessionId) { setState("failed"); return; }
    if (attempt >= 8) { setState("timeout"); return; }
    try {
      const res = await fetch(`${API}/payments/status/${sessionId}`);
      const data = await res.json();
      if (data.payment_status === "paid") { setState("success"); return; }
      if (data.status === "expired") { setState("failed"); return; }
      setTimeout(() => poll(attempt + 1), 2000);
    } catch (e) {
      setTimeout(() => poll(attempt + 1), 2000);
    }
  }, [sessionId]);

  useEffect(() => { poll(0); }, [poll]);

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-canvas px-5 py-12">
      <div className="w-full max-w-md rounded-[2rem] bg-white/70 p-9 text-center" data-testid="payment-return">
        {state === "checking" && (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-lavender/60 text-violet"><Loader2 size={30} className="animate-spin" /></span>
            <h1 className="mt-6 font-display text-3xl text-charcoal">Confirming your payment…</h1>
            <p className="mt-2 text-charcoal/55">One moment while we lock in your pickup.</p>
          </>
        )}
        {state === "success" && (
          <div data-testid="payment-success">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sage text-white"><Check size={32} /></span>
            <h1 className="mt-6 font-display text-3xl text-charcoal sm:text-4xl">Payment received — you're booked!</h1>
            <p className="mt-3 text-charcoal/60">Thank you! A receipt is on its way to your inbox, and a friendly crew will reach out to confirm your window. See you soon.</p>
            <a href="/" className="mt-7 inline-flex rounded-full bg-violet px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-violet-deep">Back to milla</a>
          </div>
        )}
        {(state === "failed" || state === "timeout") && (
          <div data-testid="payment-failed">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-stone/60 text-charcoal"><X size={24} /></span>
            <h1 className="mt-5 font-display text-3xl text-charcoal">{state === "timeout" ? "Still processing…" : "Payment not completed"}</h1>
            <p className="mt-2 text-charcoal/55">
              {state === "timeout"
                ? "Your payment is taking a moment. If you were charged, you'll get a receipt — or call us at 617-717-9852."
                : "No charge was made. You can try again or call us at 617-717-9852."}
            </p>
            <a href="/" className="mt-6 inline-flex rounded-full bg-charcoal px-7 py-3.5 text-sm font-semibold text-canvas transition-colors hover:bg-violet">Back to milla</a>
          </div>
        )}
      </div>
    </div>
  );
}
